// Cave84 — Add-Bottle flow hook (redesign)
// Single mutation that wraps the deferred-write orchestrator (services/wineGraph.ts).
// Owner-gated; invalidates every cache the graph may have touched.

import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import {
  submitAddBottleFlow,
  type AddBottleFlowInput,
  type AddBottleFlowResult
} from '@/services/wineGraph';
import { qk } from '@/services/firestore';
import { useAuthStore } from '@/stores/auth.store';

function assertOwner() {
  const role = useAuthStore.getState().userDoc?.role;
  if (role !== 'owner') throw new Error('Cave84: this mutation requires the owner role.');
}

export function useAddBottleFlow(): UseMutationResult<AddBottleFlowResult, Error, AddBottleFlowInput> {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: AddBottleFlowInput) => {
      assertOwner();
      return submitAddBottleFlow(input);
    },
    onSuccess: (_res, input) => {
      void qc.invalidateQueries({ queryKey: qk.producers.all });
      void qc.invalidateQueries({ queryKey: qk.appellations.all });
      void qc.invalidateQueries({ queryKey: qk.wines.all });
      void qc.invalidateQueries({ queryKey: qk.vintages.all });
      void qc.invalidateQueries({ queryKey: qk.bottles.all });
      void qc.invalidateQueries({ queryKey: qk.cellars.all });
      void qc.invalidateQueries({ queryKey: qk.bottles.byCellar(input.bottle.current_cellar_id) });
    }
  });
}
